import { useMemo } from 'react';
import { Button, ButtonGroup } from '@cbhq/cds-web/buttons';
import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';
import { Box, Grid, HStack, VStack } from '@cbhq/cds-web/layout';
import { TextDisplay2, TextTitle3, TextTitle4 } from '@cbhq/cds-web/typography';

import { ReactComponent as OnrampHero } from ':cloud/assets/Products/Onramp-hero.svg';
import { useAppState } from ':cloud/contexts/AppStateContext';
import { ONRAMP_DISCORD_LINK, ONRAMP_DOCS_LINK } from ':cloud/utils/links';
import { onExternalLinkPress } from ':cloud/utils/onExternalLinkPress';
import { DomainAllowlistSection } from ':cloud/widgets/onramp/DomainAllowlistSection';
import { SecureInitializationSection } from ':cloud/widgets/onramp/SecureInitializationSection';
import { WalletNameSection } from ':cloud/widgets/onramp/WalletNameSection';
import { FULL_PAGE_MAX_WIDTH } from ':cloud/widgets/product/constants';

export function OnrampOverview() {
  const title = 'Grow users with no fee USDC onramping';
  const description =
    'We make it simple for users to fund their wallets with 100+ tokens, no fees on USDC, and support for 60+ fiat currencies.';

  const { selectedProject } = useAppState();
  const { isDesktop } = useBreakpoints();
  const responsiveTemplateColumns = useMemo(() => {
    return isDesktop ? '1fr 1fr' : '1fr';
  }, [isDesktop]);
  return (
    <VStack>
      <HStack maxWidth={FULL_PAGE_MAX_WIDTH}>
        <Grid
          maxWidth={FULL_PAGE_MAX_WIDTH}
          gap={9}
          spacingHorizontal={9}
          spacingVertical={5}
          templateColumns={responsiveTemplateColumns}
          alignItems="center"
        >
          <VStack spacingVertical={4} maxHeight="max-content">
            <TextDisplay2 as="h1">{title}</TextDisplay2>
            <TextTitle4 as="h2" color="foregroundMuted" spacingTop={5} spacingBottom={7}>
              {description}
            </TextTitle4>
            <ButtonGroup>
              <Button
                variant="primary"
                endIcon="diagonalUpArrow"
                onPress={onExternalLinkPress(ONRAMP_DOCS_LINK)}
                accessibilityLabel="View docs + opens in new window"
              >
                View docs
              </Button>
              <Button
                variant="secondary"
                endIcon="diagonalUpArrow"
                onPress={onExternalLinkPress(ONRAMP_DISCORD_LINK)}
                accessibilityLabel="View docs + opens in new window"
              >
                Discord channel
              </Button>
            </ButtonGroup>
          </VStack>
          <Box borderRadius="roundedLarge" height="max-content" overflow="hidden">
            <OnrampHero width="auto" height="100%" />
          </Box>
        </Grid>
      </HStack>
      {selectedProject && (
        <VStack borderedBottom>
          <VStack maxWidth={FULL_PAGE_MAX_WIDTH} spacing={10} gap={5}>
            <HStack alignItems="center" gap={2}>
              <TextTitle3 as="h1">Configuration</TextTitle3>
            </HStack>
            <WalletNameSection project={selectedProject} />
            <SecureInitializationSection project={selectedProject} />
            <DomainAllowlistSection project={selectedProject} />
          </VStack>
        </VStack>
      )}
    </VStack>
  );
}
